import { render } from "./index.vue?vue&type=template&id=eb2b4652&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=eb2b4652&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-eb2b4652"

export default script